import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-8"
}
const _hoisted_2 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass({ required: _ctx.input.required })
          }, _toDisplayString(_ctx.input.label), 3)
        ]),
        _createVNode(_component_Field, {
          as: "textarea",
          class: "form-control form-control-solid",
          name: _ctx.input.name,
          modelValue: _ctx.model,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
          placeholder: _ctx.input.name
        }, null, 8, ["name", "modelValue", "placeholder"]),
        _createVNode(_component_ErrorMessage, {
          name: _ctx.input.name
        }, null, 8, ["name"])
      ]))
    : _createCommentVNode("", true)
}